import { SectionHeading } from '@/components/ui/SectionHeading';
import { AnimateIn } from '@/components/ui/AnimateIn';
import { PhoneMockup } from '@/components/ui/PhoneMockup';
import { Button } from '@/components/ui/Button';
import { SHOPPER_FEATURES } from '@/data/content';
import { scrollToId } from '@/lib/utils';

function CheckIcon() {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="flex-shrink-0 text-brand-500"
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

export function ForShoppers() {
  return (
    <section id="shoppers" className="bg-white py-24">
      <div className="container mx-auto px-6">
        <SectionHeading
          eyebrow="For Shoppers"
          title="Deals that reward your hustle"
          className="mb-16 lg:hidden"
        />

        <div className="flex flex-col items-center gap-16 lg:flex-row">
          {/* Left - Features */}
          <div className="flex-1">
            <SectionHeading
              eyebrow="For Shoppers"
              title="Deals that reward your hustle"
              align="left"
              className="mb-10 hidden lg:flex"
            />
            <ul className="space-y-6">
              {SHOPPER_FEATURES.map((feature, index) => (
                <AnimateIn key={feature.title} delay={index * 100}>
                  <li className="flex gap-4">
                    <CheckIcon />
                    <div>
                      <h3 className="font-semibold text-gray-900">
                        {feature.title}
                      </h3>
                      <p className="mt-1 text-sm text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </li>
                </AnimateIn>
              ))}
            </ul>
            <div className="mt-10">
              <Button size="lg" onClick={() => scrollToId('waitlist')}>
                Join Shopper Waitlist
              </Button>
            </div>
          </div>

          {/* Right - Phone Mockup */}
          <div className="flex-shrink-0">
            <PhoneMockup>
              <div className="p-4 pt-10">
                {/* Header */}
                <div className="flex items-center gap-2 px-1">
                  <div className="h-6 w-6 rounded-full bg-brand-500" />
                  <span className="text-sm font-bold text-white">
                    Run2Sale
                  </span>
                </div>

                {/* Notification card */}
                <div className="mt-4 rounded-xl bg-white/10 p-3">
                  <div className="flex items-center gap-2">
                    <span className="h-2 w-2 animate-pulse rounded-full bg-green-400" />
                    <span className="text-xs font-medium text-green-400">
                      LIVE DEAL
                    </span>
                  </div>
                  <p className="mt-2 text-sm font-semibold text-white">
                    Artisan Coffee Roasters
                  </p>
                  <p className="text-xs text-gray-400">0.3 km away</p>
                  <div className="mt-2 flex items-baseline gap-2">
                    <span className="text-lg font-bold text-brand-400">
                      50% off
                    </span>
                    <span className="text-xs text-gray-500">4:32 left</span>
                  </div>
                </div>

                {/* Second card */}
                <div className="mt-3 rounded-xl bg-white/5 p-3 opacity-60">
                  <p className="text-sm font-semibold text-white">
                    Urban Sneaker Co.
                  </p>
                  <p className="text-xs text-gray-400">1.1 km away</p>
                  <div className="mt-1 flex items-baseline gap-2">
                    <span className="text-sm font-bold text-yellow-400">
                      30% off
                    </span>
                    <span className="text-xs text-gray-500">12:05 left</span>
                  </div>
                </div>

                {/* CTA */}
                <button className="mt-4 w-full rounded-xl bg-brand-500 py-2.5 text-sm font-semibold text-white">
                  Claim Now
                </button>

                <div className="h-6" />
              </div>
            </PhoneMockup>
          </div>
        </div>
      </div>
    </section>
  );
}
